export default "__VITE_ASSET__hGBiWJVh__"